var espresso = espresso || {},
    dbp = dbp || {};
( function () {
    'use strict';
    jQuery( function () {
        dbp.init();
    } );
    dbp.init = function () {
        jQuery(window).on("CookiebotOnConsentReady", function() {
            if(Cookiebot.consent.statistics === true) {
                function intlz(intAttempt) {
                    if (intAttempt < 100) {
                        if (window["fbq"]) {
                            dbp.tracking();
                        } else {
                            setTimeout(function () {
                                intlz(intAttempt + 1);
                            }, 100);
                        }
                    }
                }
                intlz(0);
            }
        });
    };
    dbp.tracking = function () {
        var isReceipt = jQuery( '.master-webshop-checkout-alternative-step-receipt' );
        if ( isReceipt.length ) {
            fbq( 'track', 'Purchase' );
        }
        var isDetailsPage = jQuery( '.master-webshop-and-service-details' );
        if ( isDetailsPage.length ) {
            fbq( 'track', 'ViewContent' );
        }
        if ( location.search.indexOf( 'cartcmdadd=true' ) > -1 ) {
            fbq( 'track', 'addToCart' );
        }
        var isInitCheckout = jQuery( '.js-e-checkout-form-cart' ),
            isInitCheckout2 = jQuery( '.js-master-checkout-step-delivery' );
        if ( isInitCheckout.length || isInitCheckout2.length ) {
            if ( parseInt( sessionStorage.fbInitCheckout ) !== 1 ) {
                fbq( 'track', 'InitiateCheckout' );
            }
            sessionStorage.fbInitCheckout = 1;
        }
        else {
            sessionStorage.fbInitCheckout = 0;
        }
    };
    espresso.maps.helpers.icon = function ( type ) {
        var icons = {
            standard: {
                url: '/Files/Templates/Designs/ftzmaster/assets/img/rasterized-graphics/dbp-map-marker-webshop-booking.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: false,
                name: ''
            },
            webshopBooking: {
                url: '/Files/Templates/Designs/ftzmaster/assets/img/rasterized-graphics/dbp-map-marker-webshop-booking.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Webshop / Book tid online'
            },
            webshop: {
                url: '/Files/Templates/Designs/ftzmaster/assets/img/rasterized-graphics/dbp-map-marker-webshop.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Webshop'
            },
            booking: {
                url: '/Files/Templates/Designs/ftzmaster/assets/img/rasterized-graphics/dbp-map-marker-booking.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: true,
                name: 'Book tid online'
            },
            selected: {
                url: '/Files/Templates/Designs/ftzmaster/assets/img/rasterized-graphics/dbp-map-marker-selected.png',
                anchor: new google.maps.Point( 11, 11 ),
                scaledSize: new google.maps.Size( 25, 25 ),
                permissions: false,
                name: ''
            }
        };

        if ( type === undefined ) {
            return icons;
        }
        else {
            return icons[ type ];
        }
    };
}() );


$(document).ready(function () {
    (function () {
		var input = $('#ServiceCatalog_NewProduct_ShortDescription');
		input.on('keyup', function (e) {
			$('#characters').text(160 - e.target.value.length);
		});
	}());


	// when user clicks on accept terms the checkboxes auto checks
	(function () {
		var acceptedTop = $('#EcomOrderCustomerAcceptedTop');
		var acceptedBottom = $('#EcomOrderCustomerAccepted');

		if (acceptedTop.length && acceptedBottom.length) {
			var acceptTermsBtn = $('#accept-terms-btn');
			acceptTermsBtn.click(function () {
				acceptedBottom.prop("checked", true);
				acceptedTop.prop("checked", true);
			});
		}
	})();
});
